'use strict';
const FluxConstant = require('flux-constant');


module.exports = FluxConstant.set([
    'FORGOT',
    'FORGOT_RESPONSE',
    'GET_USER_CREDS',
    'GET_USER_CREDS_RESPONSE',
    'LOGIN',
    'LOGIN_RESPONSE',
    'LOGOUT',
    'LOGOUT_RESPONSE',
    'RESET',
    'RESET_RESPONSE',
    'CLEAR'
]);



// WEBPACK FOOTER //
// ./client/pages/main/login/constants.js